import React from "react";

import Icon from "../icon/Icon";

import { ButtonTypes } from "../../types/button";

import ICONS from "../../constants/icons";

const Button = ({
  handleClick,
  buttonClass = "primary",
  type = "button",
  name,
  icon,
  iconColor,
  border,
}: ButtonTypes) => {
  return (
    <button
      className={`a-button -${buttonClass} ${
        icon ? "-withIcon -column-gap10" : ""
      } ${border ? "-border" : ""} -buttonText`}
      onClick={handleClick}
      type={type}
    >
      <span>{name}</span>
      {icon && <Icon name={ICONS.SECOND_RIGHT_ARROW} color={iconColor} />}
    </button>
  );
};

export default Button;
